<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE">Flower Power</h1>
<p class="BOD2">Crochet these flowers in lots of bright, zingy colours. Attach them to twigs and small branches for a totally unique flower display.</p>
<p class="IMAGE"><img alt="" src="images/C1-1.jpg"/></p>
<p class="IMAGE"><img alt="" src="images/C1-2.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1-1.vue?55c69d82